import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import styled from '@emotion/styled';

import useInquiries from './hooks/useInquiries';
import InquiryItem from './InquiryItem';
import InquiryItemSkeletons from './InquiryItemSkeletons';

function InquiryLogs() {
    const {
        inquiries, fetchNextPage, isPending, isFetchingNextPage,
    } = useInquiries();
    return (
        <Container spacing={4}
            fullWidth
            align='center'>
            {inquiries?.map((inquiry) => (
                <InquiryItem key={inquiry.inquiryId} inquiry={inquiry} />
            ))}
            {(isPending || isFetchingNextPage) && (
                <InquiryItemSkeletons count={isPending ? 3 : 1} />
            )}
            <InfinityScrollTrigger trigger={fetchNextPage} />
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-4);
`;

export default InquiryLogs;
